/* noinspection CssUnresolvedCustomProperty */
.list {
  gap: 1px;
}

/* noinspection CssUnresolvedCustomProperty */
.tab {
  min-height: 36px;
  border-radius: 0;
  /* #F5F5F5 / #2E2E2E per mockup */
  background-color: light-dark(var(--mantine-color-mgray-5), var(--mantine-color-dark-6));
  /* Darker/lighter than the mockup (#949494 / #777777) so the labels pass WCAG AA 4.5:1 */
  color: light-dark(var(--mantine-color-text-3), var(--mantine-color-text-6));
  border: 1px solid transparent;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;
  font-weight: 400;
  text-align: center;
  flex: 1;
  padding: 4px 2px;
}

/* noinspection CssUnresolvedCustomProperty */
.tab[data-active] {
  /* Dark #005888 is the mockup value; it has no slot in the brand scale */
  background-color: light-dark(var(--mantine-color-brand-2), #005888);
  color: light-dark(var(--mantine-color-brand-7), var(--mantine-color-brand-3));
  border-color: transparent;
  font-weight: 600;
}

.tabSection {
  margin: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  width: 100%;
}

.tabLabel {
  font-size: 10px;
  line-height: 1;
  font-weight: inherit;
  text-align: center;
  white-space: nowrap;
  display: none;
  width: 100%;
}

.tooltip {
  flex: 1;
}

@media (min-width: 30em) {
  .tab {
    gap: 4px;
    padding: 6px 4px;
  }

  .tabLabel {
    display: block;
    margin-top: 2px;
  }
}

/* noinspection CssUnresolvedCustomProperty */
.panel {
  padding-top: var(--mantine-spacing-sm);
}
